export { default, getServerSideProps } from '@views/contacts';
